import { render } from "./importSubs.vue?vue&type=template&id=2c0598b9&scoped=true"
import script from "./importSubs.vue?vue&type=script&lang=js"
export * from "./importSubs.vue?vue&type=script&lang=js"

import "./importSubs.vue?vue&type=style&index=0&id=2c0598b9&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c0598b9"]])

export default __exports__